import { boolean, date, mixed, number, object, string } from "yup";

export const DEFAULT_VALUES = {
  code: "",
  name: "",
  hasParent: false,
  parentChartOfAccount: null,
  type: "",
  isActive: true,
  initialBalance: null,
  initialBalanceEffectiveDate: null,
};

export const VALIDATION_SCHEMA = object().shape({
  code: string().required("Harus diisi"),
  name: string().required("Harus diisi"),
  hasParent: boolean().required(),
  parentChartOfAccount: mixed().when("hasParent", {
    is: true,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.nullable(),
  }),
  type: string().required("Harus diisi"),
  isActive: boolean().required(),
  initialBalance: number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(0, "Harus lebih dari atau sama dengan 0"),
  initialBalanceEffectiveDate: date().nullable(),
});
